import { usePartnerDashboardContext } from "../pages/Partner/PartnerConsole/PartnerDashboardContext";
import { usePlatformDashboardContext } from "../pages/Platform/XprobaseConsole/PlatformDashboardContext";

/** Contexto unificado do dashboard consolidado (representante ou plataforma). */
export function useConsolidatedDashboardContext() {
  const platformCtx = usePlatformDashboardContext();
  const partnerCtx = usePartnerDashboardContext();

  if (
    platformCtx &&
    (platformCtx.enabled || platformCtx.liveEnabled || platformCtx.surveysEnabled)
  ) {
    return platformCtx;
  }

  if (partnerCtx && (partnerCtx.enabled || partnerCtx.liveEnabled || partnerCtx.surveysEnabled)) {
    return { ...partnerCtx, variant: partnerCtx.variant || "partner" };
  }

  return null;
}
